import { Component, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BUTTON_CLICK, CONSTS } from './exit-modal.constants';

@Component({
  selector: 'app-exit-modal',
  templateUrl: './exit-modal.component.html',
  styleUrls: ['./exit-modal.component.scss'],
  standalone: false,
})
export class ExitModalComponent {
  private dialogRef = inject(MatDialogRef<ExitModalComponent>);
  private dialog = inject(MatDialog);

  readonly CONSTS = CONSTS;
  readonly buttonClick = BUTTON_CLICK;

  onClose(button: BUTTON_CLICK): void {
    if (button === BUTTON_CLICK.ACCEPT) {
      this.dialog.closeAll();
    } else {
      this.dialogRef.close();
    }
  }
}
